<div class="example_outer_section">
    <div class="example_top_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1>全方位提升寫作品質</h1>
                    
                    <p><span class="OpenSansFonts">Trinka</span>旨在幫助學者和技術作者，不僅檢查文法，還滿足能達到有效溝通至關重要的高級寫作需求。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>高級文法檢查，確保沒有書寫錯誤</h3>
                    <p>學術和技術寫作會出現其他工具無法捕捉到的特殊寫作錯誤。 <span class="OpenSansFonts">Trinka</span>助您一臂之力！</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>主語—動詞不一致</h4>
                        <p>Therefore, these results suggest that the hypersecretion of CRH and endorphin
                            <span>suppress</span>
                            <span class="right_word">suppresses</span> the secretion of LH and FSH from the pituitary gland.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>選詞</h4>
                        <p>The statistical analyses were performed <span>with</span> <span class="right_word">using</span> a statistical analysis software (SAS).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>介詞</h4>
                        <p>Recent years have seen an increase <span>of</span> <span class="right_word">in</span> exudation of various organic acids.</p>
                    </div>
                </div>

                <!-- <div class="col-md-12">
                    <div class="example_box_contents">
                        <h4>Subject-verb disagreement</h4>
                        <p><span><span class="OpenSansFonts">Trinka</span></span> is your personal <span>AI editor</span> for all your academic writing
                            needs. <span><span class="OpenSansFonts">Trinka</span></span> is your personal <span>AI editor</span> for all your academic
                            writing needs.</p>
                    </div>
                </div> -->

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>形容詞使用</h4>
                        <p>The group receiving the placebo treatment had the <span>most</span> highest improvement in sleep scores.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->

    <div class="exapmle_cards_heading background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>提升寫作至出版標準</h3>
                    <p><span class="OpenSansFonts">通過加強語氣</span>、風格和符合標準格式指南，Trinka能讓您的寫作更適合學術讀者。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin background_color_changes">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>簡明</h4>
                        <p>Utilities would continue to <span>have the obligation</span> <span class="right_word">be
                                obliged</span> to serve retail customers.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>正式語氣</h4>
                        <p>The <span>average</span> <span class="right_word">mean</span> age of the study group was 54.2 years (range: 890 years).</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>選詞</h4>
                        <p>The assembly <span>abrogated</span> <span class="right_word">arrogated</span> to itself the right to make changes.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>風格指南</h4>
                        <p>Substance <span>abuse</span> <span class="right_word">use disorder</span> has been a major public health concern.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


    <div class="exapmle_cards_heading">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h3>針對特定專業進行檢查並更正</h3>
                    <p><span class="OpenSansFonts">Trinka</span>瞭解每個學科領域都有其獨特的表達方式，能確保所作的更正不會篡改特定學科領域的風格。</p>
                </div>
            </div>
        </div>
    </div>

    <div class="example_boxs boxs_margin">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>電腦科學</h4>
                        <p>In our study, 90% of the users expressed the need for a <span>dialogue</span> <span class="right_word">dialog</span> box to alert them to a pending update.</p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>物理</h4>
                        <p>By contrast, the <span>effect</span> <span class="right_word">effects</span> of the Mach number and <span class="">heat</span> specific <span class="right_word">heat</span> ratio contribute little to the aerodynamic performance.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>醫學</h4>
                        <p>Our study matched for age, <span>gender</span> <span class="right_word">sex</span>, ethnicity, and BMI, marijuana use was associated with higher abdominal visceral fat.
                        </p>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="example_box_contents">
                        <h4>經濟學</h4>
                        <p>The estimated natural rate, based on the <span>past</span> history of the data, plummets by nearly 2
                            <span>percent</span> <span class="right_word">percentage</span> points.
                        </p>
                        <!-- <p>Studies have shown that organizational culture and <span>organizational</span> environment
                            now meet work-life policies.
                        </p> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- <div class="borderd_line"></div> -->


</div>